import React from 'react';

const DEPT_NAMES = {
  'kinh-doanh': 'Kinh doanh',
  'marketing': 'Marketing',
  'hcns': 'Hành chính - Nhân sự',
  'ke-toan': 'Kế toán',
  'kho-van': 'Kho vận',
  'thu-mua': 'Thu mua',
  'chuyen-mon': 'Chuyên môn'
};

export default function JobCard({ job, onOpenDetail }) {
  const departmentLabel = DEPT_NAMES[job.department] || job.department || 'Tuyển dụng';
  const requirements = Array.isArray(job.requirements) ? job.requirements : [];

  return (
    <article className="area-card job-card" style={{ padding: '32px' }}>
      <div className="job-card__badges">
        <span className="job-card__hot" aria-label="Vị trí nổi bật" title="Vị trí nổi bật">
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" width="20" height="20">
            <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z" />
          </svg>
        </span>
        {job.headcount > 0 && (
          <span className="job-card__count">Tuyển {job.headcount} nhân sự</span>
        )}
      </div>

      <span className="eyebrow" style={{ marginBottom: '6px' }}>{departmentLabel}</span>
      <h3>{job.title}</h3>

      {job.salary && (
        <p className="job-card__salary">
          <strong>Thu nhập:</strong> {job.salary}
        </p>
      )}

      {requirements.length > 0 && (
        <ul className="pod-list" style={{ marginTop: '10px' }}>
          {requirements.slice(0, 3).map((req, idx) => (
            <li key={idx}>{req}</li>
          ))}
        </ul>
      )}

      <button
        type="button"
        className="job-detail-btn"
        onClick={() => onOpenDetail(job)}
      >
        Xem chi tiết
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>
      </button>
    </article>
  );
}
